import React from 'react';

type ErrorBoundaryState = { hasError: boolean };

class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
	constructor(props: React.PropsWithChildren) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		console.error('ErrorBoundary caught an error', error, info);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="min-h-[40vh] flex items-center justify-center text-center p-6">
					<div>
						<h2 className="text-xl font-bold mb-2">Er is iets misgegaan</h2>
						<p className="text-gray-600">Ververs de pagina of probeer het later opnieuw.</p>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;

